export const RECORDING_WARN_15_S = 15 * 60;
export const RECORDING_WARN_25_S = 25 * 60;
export const RECORDING_MAX_S = 30 * 60;
